import { useRef } from "react";
function useFallbackRef(forwardedRef) {
  const innerRef = useRef(null);
  return forwardedRef ?? innerRef;
}
export {
  useFallbackRef
};
//# sourceMappingURL=useFallbackRef.js.map
